import { cookie } from '@/helpers';
import { ApiPlugin, ApiPrivatePlugin } from '@/plugins';
import UserSession from './userSession.service';

export default class Decryptage extends UserSession {
  static async getDecryptageContent(page, type, category) {
    try {
      let response;
      if (!page && !type && !category && window.API?.[0]?.['fake-news-block-same-theme']) {
        response = await ApiPlugin.get(
          `/api/fake-news?page=0&type=${window.API?.[0]?.['fake-news-block-same-theme'].type}&category=${window.API?.[0]?.['fake-news-block-same-theme'].categorie}`,
        );
      } else {
        const categoryQueryParam = category && category !== '0' ? `&category=${category}` : '';
        const typeQueryParam = type ? `&type=${type}` : '';
        response = await ApiPlugin.get(
          `/api/fake-news?page=${page}${typeQueryParam}${categoryQueryParam}`,
        );
      }

      return response.data;
    } catch (e) {
      console.error('Error fetching articles \n', e);
      return [];
    }
  }

  static async postFakeNewsQuestion(data) {
    const formData = {
      webform_id: 'fake_news_question',
      question: data,
    };

    if (!cookie.getCookie('token') || cookie.getCookie('token') === '') await this.getAPIToken();

    try {
      const response = await ApiPrivatePlugin().post(
        '/webform_rest/submit',
        JSON.stringify(formData),
      );
      return [response.data];
    } catch (e) {
      console.error('Error posting question \n', e);
      return [];
    }
  }

  static getCurrentDecryptageId() {
    return window.API[0]['fake-news-block-same-theme'].id;
  }
}
